import { Flex } from '@assets/component/UI/Flex/Flex';
import { observer } from 'mobx-react';
import * as style from './WorkstreamsPage.module.less';
import { GetIcon, Icon, icons } from '@assets/component/Icons/Icons';
import {
    UIDealDetailsTabs,
    useStore,
    useStoreUI,
    useTasksStore
} from '@assets/model/Store';
import { TaskPage } from '@assets/component/TaskPage/TaskPage';
import { useState } from 'react';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';

export const WorkStreamPage = observer(() => {
    const store = useStore();
    const taskStore = useTasksStore();
    const [taskPageOpen, setTaskPageOpen] = useState(false);

    const tasksState = store.activeReportTasksState;
    const makeTaskGroup = (title: string, taskIdsList: string[]) => {
        const tasks = taskIdsList.map(taskId => {
            const taskState = tasksState.getTaskQuery(taskId);
            //getTaskData(taskId);
            const taskDefinition = taskStore.get_task_definition(taskId);

            //defaults for static UI
            var totalSteps = 3;
            var isTaskComplete = false;
            var activeStep = 1;
            var taskName = taskId;
            var icon: icons = 'task-locked';

            if (taskDefinition) {
                totalSteps = taskDefinition.inner_steps_names.length;
                taskName = taskDefinition.name;
            }

            if (taskState) {
                isTaskComplete = taskState.isComplete;
                activeStep = taskState.activeStep;

                const taskStatus = taskState.status;

                if (taskState.isLocked) {
                    icon = 'task-locked';
                } else if (isTaskComplete) {
                    icon = 'task-checkmark';
                } else {
                    if (taskStatus == 'in_progress') {
                        icon = 'task-working';
                    } else {
                        icon = 'task-paused'; //# or locked ?
                    }
                }
            }

            var workItemsString = `${activeStep}/${totalSteps} Work items completed`;

            return (
                <div key={taskId} className={style.taskBox}>
                    <Flex
                        fillCell={true}
                        direction="row"
                        className={style.taskBoxContent}
                    >
                        <Flex direction="column" fillCell={true}>
                            <div
                                className={style.taskTitle}
                                onClick={() => {
                                    if (!taskDefinition) return;

                                    store.selectedTaskId = taskId;
                                    setTaskPageOpen(true);
                                }}
                            >
                                {taskName}
                            </div>
                            <div style={{ flexGrow: 1 }}></div>
                            <div className={style.taskStatus}>
                                {workItemsString}
                            </div>
                        </Flex>
                        <div className={style.taskIcon}>
                            <img
                                src={GetIcon(icon)}
                                className={style.iconSize}
                            />
                        </div>
                    </Flex>
                </div>
            );
        });

        return (
            <Flex
                fillCell={true}
                direction="column"
                className={style.taskGroup}
            >
                <div className={style.taskGroupTitle}>{title}</div>
                {tasks}
            </Flex>
        );
    };

    const onClickClear = () => {
        const areYouSure = window.confirm('Are you sure you want to clear?');

        if (!areYouSure) return;

        const fb = getFirebase();
        const reportId = store.selectedReportId;
        const tasksToClear = [
            'identify_industry',
            'competitive_landscape',
            'industry_history'
        ];

        for (const taskId of tasksToClear) {
            fb.flowtask_add_clear_job(reportId, taskId);
        }
    };
    return (
        <>
            <i
                className={'bi bi-trash' + ' ' + style.clearButton}
                style={{
                    color: 'black',
                    display: taskPageOpen ? 'none' : 'block'
                }}
                onClick={() => {
                    onClickClear();
                }}
            ></i>
            <div
                className={style.taskViewContainer}
                style={{
                    display: taskPageOpen ? 'block' : 'none'
                }}
            >
                <TaskPage
                    onClickBack={() => {
                        setTaskPageOpen(false);
                    }}
                />
            </div>
            <Flex direction="row" className={style.flexsContainer}>
                {makeTaskGroup('Market', [
                    'identify_industry',
                    'industry_history',
                    'Size & Growth',
                    'Segmentation',
                    'Headwinds & Tailwinds',
                    'Value chain'
                ])}
                {makeTaskGroup('Company', [
                    'Business overview',
                    'Opportunity overview',
                    'Customers',
                    'History',
                    'Management'
                ])}
                {makeTaskGroup('Voice of the Customer', [
                    'Purchasing process',
                    'Channel references',
                    'Key purchasing criteria'
                ])}
                {makeTaskGroup('Competitive landscape', [
                    'competitive_landscape',
                    'Entry barriers'
                ])}
                {makeTaskGroup('What we need to believe', [
                    'Size & Growth',
                    'Segmentation',
                    'Headwinds & Tailwinds',
                    'Value chain'
                ])}
            </Flex>
        </>
    );
});
